import { css } from "emotion";
import { prop } from "ramda";
import React, { useCallback, useEffect, useLayoutEffect, useRef } from "react";
import { QsDashboard } from "@kofile/platform-report-visualization";
import { isPresent } from "../../utils";
import connect from "./connect";

if (
  typeof window !== "undefined" &&
  window.customElements &&
  !customElements.get("qs-dashboard")
) {
  customElements.define("qs-dashboard", QsDashboard);
}

const style = {
  page: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px 40px;
  `,
  toolbar: css`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    label {
      font-weight: 600;
    }

    select {
      min-width: 320px;
      padding: 6px 10px;
    }
  `,
  frameWrap: css`
    flex: 1;
    min-height: 600px;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
  `,
  dashboard: css`
    display: block;
    width: 100%;
    height: 100%;
  `,
  message: css`
    padding: 40px;
    font-size: 1.2em;
    color: #555;
  `,
  error: css`
    padding: 20px 40px;
    color: #b00020;
  `,
};

export const Analytics = (props) => {
  const {
    listDashboards,
    getEmbedUrl,
    reset,
    dashboards,
    selectedDashboardId,
    embed,
    loadingDashboards,
    loadingEmbed,
    error,
  } = props;

  const elRef = useRef(null);
  const setRef = useCallback((node) => {
    elRef.current = node;
  }, []);

  useEffect(() => {
    listDashboards();
    return () => reset();
  }, []);

  const onSelect = (e) => {
    const id = e.target.value;
    if (id) getEmbedUrl(id);
  };

  const embedUrl = prop("url", embed);
  const theme = prop("theme", embed);

  useLayoutEffect(() => {
    const el = elRef.current;
    if (!el || !isPresent(embedUrl)) return;

    el.dashboards = selectedDashboardId ? [selectedDashboardId] : [];
    if (isPresent(theme)) el.setAttribute("theme-arn", theme);
    el.setAttribute("embed-url", embedUrl);
  }, [embedUrl, theme, selectedDashboardId]);

  return (
    <div className={style.page}>
      <div className={style.toolbar}>
        <label htmlFor="dashboard-select">Report</label>
        <select
          id="dashboard-select"
          value={selectedDashboardId || ""}
          onChange={onSelect}
          disabled={loadingDashboards || dashboards.length === 0}
        >
          <option value="" disabled>
            {loadingDashboards ? "Loading dashboards..." : "Select a dashboard"}
          </option>
          {dashboards.map((d) => (
            <option key={d.DashboardId} value={d.DashboardId}>
              {d.Name}
            </option>
          ))}
        </select>
      </div>

      {isPresent(error) && (
        <div className={style.error}>
          Something went wrong loading the report. Please try again.
        </div>
      )}

      <div className={style.frameWrap}>
        {loadingEmbed && <div className={style.message}>Loading report...</div>}
        {!loadingEmbed && isPresent(embedUrl) && (
          <qs-dashboard ref={setRef} className={style.dashboard} />
        )}
        {!loadingEmbed && !isPresent(embedUrl) && (
          <div className={style.message}>Select a report above to view it.</div>
        )}
      </div>
    </div>
  );
};

export default connect(Analytics);
